import { createAction } from '@reduxjs/toolkit'

export const showLogin = createAction<{showLogin: boolean}>('popup/showLogin');

export const showPopup = createAction<{payload: any, request: any}>('popup/showPopup');

export const requestChainName = createAction<{requestChainName: string}>('popup/requestChainName');

